import { useContext } from 'react';
import { TeamsFxContext } from 'src/context/TeamsContext';
import { HeaderWrapper, Title } from './TicketDetailsTabHeader.styled';
import { Dismiss20Regular } from '@fluentui/react-icons';

interface TicketDetailsTabHeaderProps {
  onClose: () => void;
}

export const TicketDetailsTabHeader = ({onClose}: TicketDetailsTabHeaderProps) => {
    const { themeString } = useContext(TeamsFxContext);

    return (
        <HeaderWrapper style={{ background: themeString !== 'dark' && 'white'}} >
          <Title>Ticket Details</Title>
          <Dismiss20Regular onClick={onClose}/>
        </HeaderWrapper>
      );
}